import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import BasePickerComponent from '../BasePickerComponent';
import useStyles from './styles';
import { parseN } from '../utils';

const TimePicker = ({
  value, setTime, onSave, onGoBack,
}) => {
  const { t } = useTranslation(['translation']);
  const classes = useStyles();
  const currentHour = Number(value.split(':')[0]);
  const shortHour = currentHour >= 12 ? currentHour - 12 : currentHour;
  const [amOrPm, setAmOrPm] = useState(currentHour >= 12 ? 'pm' : 'am');
  const [currentAngle, setCurrentAngle] = useState((shortHour - 6) * 30);
  const hours = [...Array(12)].map((x, i) => i + 1);

  const onHourClick = hour => {
    // setCurrentAngle((hour - 6) * 30);
    if (Math.abs(shortHour - hour) <= 6) {
      setCurrentAngle(currentAngle + (hour - shortHour) * 30);
    } else {
      const amendment = hour > shortHour ? -12 : 12;
      setCurrentAngle(currentAngle + (hour - shortHour + amendment) * 30);
    }
    const trueHour = hour + (amOrPm === 'pm' ? 12 : 0);
    setTime(`${parseN(trueHour)}:00`);
  };

  const toggleAmOrPm = () => {
    if (amOrPm === 'am') {
      setAmOrPm('pm');
      setTime(`${parseN(currentHour + 12)}:00`);
    } else {
      setAmOrPm('am');
      setTime(`${parseN(currentHour - 12)}:00`);
    }
  };

  return (
    <BasePickerComponent
      title={t('COMMON.TIME_PICKER.TITLE')}
      primaryButtonText={t('COMMON.TIME_PICKER.PRIMARY_BUTTON_TEXT')}
      secondaryButtonText={t('COMMON.TIME_PICKER.SECONDARY_BUTTON_TEXT')}
      onSecondaryClick={onGoBack}
      onPrimaryClick={onSave}
    >
      <div className={classes.container}>
        <div className={classes.clockContainer}>
          {hours.map(hour => {
            const angle = hour * (Math.PI / 6);
            const dx = 120 * Math.sin(angle);
            const dy = -120 * Math.cos(angle);
            return (
              <div
                key={hour}
                className={classnames(
                  classes.hourSymbol,
                  {
                    [classes.selected]: hour === shortHour,
                    [classes.hoverable]: hour !== shortHour,
                  },

                )}
                style={{
                  transform: `translate(${dx}px, ${dy}px)`,
                }}
                role="button"
                tabIndex={0}
                onClick={() => { onHourClick(hour); }}
                onKeyPress={() => { onHourClick(hour); }}
              >
                {hour}
              </div>
            );
          })}
          <div
            className={classes.arrow}
            style={{
              transform: `rotate(${currentAngle}deg)`,
            }}
          />
        </div>
        <div
          className={classes.amDiv}
          role="button"
          tabIndex={0}
          onClick={toggleAmOrPm}
          onKeyPress={toggleAmOrPm}
        >
          <span>{amOrPm}</span>
        </div>
      </div>
    </BasePickerComponent>
  );
};


TimePicker.propTypes = {
  value: PropTypes.string.isRequired,
  setTime: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onGoBack: PropTypes.func.isRequired,
};

export default TimePicker;
